import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { applyAnalyticsOptOut } from '../lib/analytics';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext();

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null = checking, false = not auth, object = authed
  const [token, setToken] = useState(localStorage.getItem('admin_token'));

  useEffect(() => {
    const checkAuth = async () => {
      const storedToken = localStorage.getItem('admin_token');
      if (!storedToken) {
        setAdmin(false);
        return;
      }
      try {
        const { data } = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${storedToken}` },
          withCredentials: true
        });
        setAdmin(data);
      } catch (e) {
        localStorage.removeItem('admin_token');
        applyAnalyticsOptOut();
        setToken(null);
        setAdmin(false);
      }
    };
    checkAuth();
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(
      `${API}/auth/login`,
      { email, password },
      { withCredentials: true }
    );
    localStorage.setItem('admin_token', data.token);
    applyAnalyticsOptOut();
    setToken(data.token);
    setAdmin({ email: data.email, role: data.role });
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (e) { /* ignore */ }
    localStorage.removeItem('admin_token');
    setToken(null);
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
